import { API_STATUSES } from 'redux/_helpers/statuses';

import { createSlice, current } from '@reduxjs/toolkit';

const persistedLocalStorageReducer = createSlice({
  name: "persistedLocalStorageReducer",
  initialState: {
    siteIdData: null, // Contains siteNumber
    beepOnNewMessage:true,
    beepWhileNotEmpty:true,
    popupOnNewMessage:false,
    getOnlyMessagesCarData:[],
    dismissedMessageIDs:[],
    appDataReduxState:{
      siteNumberData:null,
      siteName:null,
      courseNumber:null,
      courseName:"",
      coursesData:[],
      distanceunits:null,
    },
    printDataReduxState:{
      measurementData:{},
      visageVersion:"",
      printDate: "",
      rotationName:""
    },
    courseNumberReduxState:null, // Contains Course Number 
    selectedPinReduxStateFromStorage:{
      circle:null,
      x:null,
      y:null
    },
    updatedPinLocationReduxStateToStorage:[],
    pinsImagesReduxStateData:[],
    AreaFilterData: [],
    HolesFilterData: [],
    TeeFilterData: [],
    PointFilterData: [],
    siteIdDataRequest: API_STATUSES.REQUEST,
    approachViewData: [],
    approachViewDataStatus: API_STATUSES.REQUEST,
    viewGridsReduxState:true, // Enable and Disable Grids Button
    viewActivePinsReduxState: false,
    dirtyEditPinsFlagReduxState:false,
    // pinsEditModeReduxState: false, // Enable and Disable Edit Button
    viewMeasurementReduxState:false, // Enable and Disable Measurement Button
    viewMeasureFromReduxState: "front-closest", // Initial Course dimensions for Course
    activeMeasurementButtonReduxState:false,
    activeMarkerReduxState:"",
    selectedPinReduxState:null,
    holeDataReduxState:[],
    siteSettingsDataReduxState:[], // This contains all site data from "GetSiteSettings" Api
    viewDistanceYardsReduxState:null, // For Changing Course Dimensions from "Yards" to "Meters" or Vice Versa.
    selectedMeasurementPinReduxState:"", // Selected Pins Data from Dropdown
    AreaDataReduxState: [],
    TeeDataReduxState: [],
    PointDataReduxState: [],
    activeOnlyReduxState:false,
    runJSFile:null,
    carMessagesBackup:[],
    carMessagesBackup2:[],
    previousDateReduxState:""
  },
  reducers: {
    jsFileRunner:(state,action) => {
      state.runJSFile = action.payload
    },
    setBeepOnNewMessageAction:(state,{ payload }) => {
      state.beepOnNewMessage = payload
    },
    setBeepWhileNotEmptyAction:(state,{ payload }) => {
      state.beepWhileNotEmpty = payload
    },
    setPopupOnNewMessageAction:(state,{ payload }) => {
      state.popupOnNewMessage = payload
    },
    setDismissedMessageIDAction:(state,{ payload }) => {
      state.dismissedMessageIDs = [...state.dismissedMessageIDs,payload]
    },
    setSiteIdData: (state, action) => {
      state.siteIdData = action.payload;
    },
    setOnlyMessagesReduxState:(state,action) => {
      state.getOnlyMessagesCarData = action.payload
    },
    setOldMessagesBackUpReduxState:() => {

    },
    deleteMessagesReduxState:(state, action) => {
      const { id } = action.payload;
      const newData = state.getOnlyMessagesCarData.filter((item) => item.Id !== id);
      state.getOnlyMessagesCarData = newData
    },
    previousDateLoaderReduxAction:(state, action) => {
      state.previousDateReduxState = action.payload
    },

    //clear the backup arrays or adding new messages.
    clearMessagesBackupDataReduxAction:(state, action) => {
      state.carMessagesBackup = [];
      state.carMessagesBackup2 = []
    },
    setCarMessagesBackup:(state, action) => {
      if(action.payload && action.payload.length >= 1){
          state.carMessagesBackup = [
          ...state.carMessagesBackup,
          ...action.payload
        ]
      }else{
           state.carMessagesBackup = [
          ...state.carMessagesBackup,
          action.payload
        ]
      }
    },
    setCarMessagesDataBackup:(state, action) => {
      if(action.payload && action.payload.length >= 1){
        state.carMessagesBackup2 = [
          ...state.carMessagesBackup2,
          ...action.payload
        ]
      }else{
        state.carMessagesBackup2 = [
          ...state.carMessagesBackup2,
          action.payload
        ]
      }
    },
    setAppDataReduxStateAction:(state,action) => {
      const { value, parameterDetector } = action.payload;
      if(parameterDetector === "coursenumber"){
        state.appDataReduxState = {
          ...state.appDataReduxState,
          courseNumber:value
        }
      }else if(parameterDetector === "coursename"){
        state.appDataReduxState = {
          ...state.appDataReduxState,
          courseName:value
        }
      }else if(parameterDetector === "sitenumber"){
        state.appDataReduxState = {
          ...state.appDataReduxState,
          siteNumberData:value
        }
      }else if(parameterDetector === "sitename"){
        state.appDataReduxState = {
          ...state.appDataReduxState,
          siteName:value
        }
      }else if(parameterDetector === "coursesdata"){
        state.appDataReduxState = {
          ...state.appDataReduxState,
          coursesData:value
        }
      }else if(parameterDetector === "distanceunits"){
        state.appDataReduxState = {
          ...state.appDataReduxState,
          distanceunits:value
        }
      }
    },
    setPrintDataReduxStateAction:(state,action) => {
      const { parameterDetector, value } = action.payload
      if(parameterDetector === "rotationName"){
        state.printDataReduxState = {
          ...state.printDataReduxState,
          rotationName:value
        }
      }else if(parameterDetector === "visageVersion"){
        state.printDataReduxState = {
          ...state.printDataReduxState,
          visageVersion:value
        }
      }else if(parameterDetector === "printDate"){
        state.printDataReduxState = {
          ...state.printDataReduxState,
          printDate:value
        }
      }else if(parameterDetector === "measurementData"){
        state.printDataReduxState = {
          ...state.printDataReduxState,
          measurementData:{
            ...state.printDataReduxState.measurementData,
            value
          }
        }
      }
    },
    setUpdatedPinLocationReduxStateToStorage:(state,action) => {
      state.updatedPinLocationReduxStateToStorage = action.payload
    },
    setPinsImagesReduxStateDataAction:(state, action) => {
      if(Object.keys(action.payload).length !== 0){
        state.pinsImagesReduxStateData = [
          ...state.pinsImagesReduxStateData,
          action.payload,
        ]
      }
    },
    setCourseNumberReduxStateAction: (state, action) => {
      state.courseNumberReduxState = action.payload;
    },
    setAreaFilterData: (state, action) => {
      state.AreaFilterData = action.payload;
    },
    setHolesFilterData: (state, action) => {
      state.HolesFilterData = action.payload;
    },
    setTeeFilterData: (state, action) => {
      state.TeeFilterData = action.payload;
    },
    setPointFilterData: (state, action) => {
      state.PointFilterData = action.payload;
    },
    setHoleReduxStateAction:(state, action) => {
      const exists = current(state?.holeDataReduxState).find((item) => item?.Hole === action.payload.Hole)
      if(exists){
        current(state?.holeDataReduxState).filter((item) => item?.Hole !== action.payload.Hole);
      }else{
        state.holeDataReduxState = [...state.holeDataReduxState,action.payload]
      }
    },
    setApproachViewsData: (state, action) => {
      const exists = state.approachViewData.find(
        (item) => item === action.payload
      );
      if (exists) {
        state.approachViewData.filter((item) => item !== action.payload);
      } else {
        state.approachViewData = [...state.approachViewData, action.payload];
        state.approachViewDataStatus = API_STATUSES.SUCCESS;
      }
    },
    setGridsViewReduxStateAction:(state,action) => {
      state.viewGridsReduxState = action.payload
    },
    setViewActivePinsReduxStateAction: (state, action) => {
      state.viewActivePinsReduxState = action.payload;
    },
    setDirtyEditPinsFlagReduxStateAction:(state, action) => {
      state.dirtyEditPinsFlagReduxState = action.payload
    },
    setViewMeasurementReduxStateAction:(state, action) => {
      state.viewMeasurementReduxState = action.payload;
    },
    setViewMeasureFromReduxStateAction: (state, action) => {
      state.viewMeasureFromReduxState = action.payload;
    },
    activeMeasurementButtonAction: (state, action) => {
      state.activeMeasurementButtonReduxState = action.payload;
    },
    setActiveMarkerReduxStateAction:(state, action) => {
      state.activeMarkerReduxState = action.payload
    },
    setSelectedPinReduxStateAction:(state,action) => {
      state.selectedPinReduxState = action.payload
    },
    setHoleDataReduxStateAction:(state,action) => {
      state.holeDataReduxState = action.payload
    },
    setSiteSettingsDataAction:(state,action) => {
      state.siteSettingsDataReduxState = action.payload
    },
    setViewDistanceYardsAction:(state,action) => {
      state.viewDistanceYardsReduxState = action.payload
    },
    setSelectedMeasurementPinReduxStateAction:(state, action) => {
      state.selectedMeasurementPinReduxState = action.payload
    },
    setActiveOnlyReduxStateAction:(state,action) => {
      state.activeOnlyReduxState = action.payload
    }
  },
});

export const {
  setSiteIdData,
  setBeepOnNewMessageAction,
  setBeepWhileNotEmptyAction,
  setPopupOnNewMessageAction,
  setDismissedMessageIDAction,
  setPrintDataReduxStateAction,
  setCourseNumberReduxStateAction,
  setPinsImagesReduxStateDataAction,
  setSelectedPinMovementReduxStateToStorage,
  setUpdatedPinLocationReduxStateToStorage,
  setAreaFilterData,
  setHolesFilterData,
  setTeeFilterData,
  setPointFilterData,
  setApproachViewsData,
  setGridsViewReduxStateAction,
  setViewActivePinsReduxStateAction,
  previousDateLoaderReduxAction,
  setViewMeasureFromReduxStateAction,
  setActiveMarkerReduxStateAction,
  setSelectedPinReduxStateAction,
  setHoleDataReduxStateAction,
  setSiteSettingsDataAction,
  setViewDistanceYardsAction,
  activeMeasurementButtonAction,
  setViewMeasurementReduxStateAction,
  setSelectedMeasurementPinReduxStateAction,
  setDirtyEditPinsFlagReduxStateAction,
  setHoleReduxStateAction,
  setActiveOnlyReduxStateAction,
  jsFileRunner,
  setOnlyMessagesReduxState,
  deleteMessagesReduxState,
  setCarMessagesBackup,
  setCarMessagesDataBackup,
  clearMessagesBackupDataReduxAction,
  setAppDataReduxStateAction
} = persistedLocalStorageReducer.actions;
export default persistedLocalStorageReducer.reducer;
